import { render } from "./1.vue?vue&type=template&id=6c5e0586&scoped=true"
import script from "./1.vue?vue&type=script&lang=js"
export * from "./1.vue?vue&type=script&lang=js"

import "./1.vue?vue&type=style&index=0&id=6c5e0586&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5e0586"]])

export default __exports__